<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Equipe A (Domicile)</label>
      </div>
      <select name="match_equipe_a"
              disabled
              class="custom-select">
        <option>{{ (equipe_a && equipe_a.nom) ? equipe_a.nom : '' }}</option>
    </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Equipe B (Extérieur)</label>
      </div>
      <select name="match_equipe_b"
              disabled
              class="custom-select">
        <option>{{ (equipe_b && equipe_b.nom) ? equipe_b.nom : '' }}</option>
    </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de rencontre</span>
      </div>
      <input :value="match.date_rencontre"
             name="match_date_rencontre"
             disabled
             type="text"
             class="form-control">
      <input :value="match.temps_rencontre"
             name="match_temps_rencontre"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Terrain</label>
      </div>
      <select name="match_terrain"
              disabled
              class="custom-select">
        <option>{{ (terrain && terrain.nom) ? terrain.nom : '' }}</option>
    </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Arbitre Principal</label>
      </div>
      <select name="match_arbitre_principal"
              disabled
              class="custom-select">
        <option>{{
            (arbitre_principal && arbitre_principal.prenom && arbitre_principal.postnom && arbitre_principal.nom) ?
            (arbitre_principal.prenom + ' ' + arbitre_principal.postnom + ' ' + arbitre_principal.nom) :  '' }}
        </option>
    </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Arbitre Assistant 1</label>
      </div>
      <select name="match_arbitre_assistant_1"
              disabled
              class="custom-select">
        <option>
          {{ (arbitre_assistant_1 && arbitre_assistant_1.prenom && arbitre_assistant_1.postnom && arbitre_assistant_1.nom) ?
            (arbitre_assistant_1.prenom + ' ' + arbitre_assistant_1.postnom + ' ' + arbitre_assistant_1.nom) :  '' }}
        </option>
    </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Arbitre Assistant 2</label>
      </div>
      <select name="match_arbitre_assistant_2"
              disabled
              class="custom-select">
        <option>
          {{ (arbitre_assistant_2 && arbitre_assistant_2.prenom && arbitre_assistant_2.postnom && arbitre_assistant_2.nom) ?
             (arbitre_assistant_2.prenom + ' ' + arbitre_assistant_2.postnom + ' ' + arbitre_assistant_2.nom) :  '' }}
        </option>
    </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Arbitre Commissaire</label>
      </div>
      <select name="match_arbitre_commissaire"
              disabled
              class="custom-select">
        <option>
          {{ (arbitre_commissaire && arbitre_commissaire.prenom && arbitre_commissaire.postnom && arbitre_commissaire.nom) ?
             (arbitre_commissaire.prenom + ' ' + arbitre_commissaire.postnom + ' ' + arbitre_commissaire.nom) :  '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Saison</label>
      </div>
      <select name="match_saison"
              disabled
              class="custom-select">
        <option>
          {{ (saison) ? saison.annee_debut : "" }} -
          {{ (saison) ? saison.annee_fin : ""  }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Championnat</label>
      </div>
      <select name="match_championnat"
              disabled
              class="custom-select">
        <option>
          {{ (championnat) ? championnat.nom : "" }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Phase</label>
      </div>
      <select name="match_match"
              disabled
              class="custom-select">
        <option>
          {{ (match) ? match.phase : "" }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Journée</label>
      </div>
      <select name="match_journee"
              disabled
              class="custom-select">
        <option>
          {{ (match) ? match.journee : ""  }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de creation</span>
      </div>
      <input :value="match.date_creation"
             name="match_date_creation"
             disabled
             type="date"
             class="form-control">
      <input :value="match.temps_creation"
             name="match_temps_creation"
             disabled
             type="time"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de mise à jour</span>
      </div>
      <input :value="match.date_modification"
             name="match_date_modification"
             disabled
             type="date"
             class="form-control">
      <input :value="match.temps_modification"
             name="match_temps_modification"
             disabled
             type="time"
             class="form-control">
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Read",
  props: {
    match: {
      type: Object
    }
  },
  data(){
    return{
      equipe_a: null,
      equipe_b: null,
      terrain: null,
      arbitre_principal: null,
      arbitre_assistant_1: null,
      arbitre_assistant_2: null,
      arbitre_commissaire: null,
      saison: null,
      championnat: null,
      phase: null,
      journee: null,
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetOneData'
    ]),
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {
    //
    this.axiosGetOneData({
      table: "equipes",
      table_id: this.match.equipe_a_id
    })
        .then( (data) => {
          this.equipe_a = data.data
        })
        .catch( (error) => {

        })
    //
    this.axiosGetOneData({
      table: "equipes",
      table_id: this.match.equipe_b_id
    })
        .then( (data) => {
          this.equipe_b = data.data
        })
        .catch( (error) => {

        })
    //
    this.axiosGetOneData({
      table: "terrains",
      table_id: this.match.terrain_id
    })
        .then( (data) => {
          this.terrain = data.data
        })
        .catch( (error) => {

        })
    //
    this.axiosGetOneData({
      table: "arbitres",
      table_id: this.match.arbitre_principal_id
    })
        .then( (data) => {
          this.arbitre_principal = data.data
        })
        .catch( (error) => {

        })
    //
    this.axiosGetOneData({
      table: "arbitres",
      table_id: this.match.arbitre_assistant_1_id
    })
        .then( (data) => {
          this.arbitre_assistant_1 = data.data
        })
        .catch( (error) => {

        })
    //
    this.axiosGetOneData({
      table: "arbitres",
      table_id: this.match.arbitre_assistant_2_id
    })
        .then( (data) => {
          this.arbitre_assistant_2 = data.data
        })
        .catch( (error) => {

        })
    //
    this.axiosGetOneData({
      table: "arbitres",
      table_id: this.match.arbitre_commissaire_id
    })
        .then( (data) => {
          this.arbitre_commissaire = data.data
        })
        .catch( (error) => {

        })
    //
    this.axiosGetOneData({
      table: "saisons",
      table_id: this.match.saison_id
    })
        .then( (data) => {
          this.saison = data.data
        })
        .catch( (error) => {

        })
    //
    this.axiosGetOneData({
      table: "championnats",
      table_id: this.match.championnat_id
    })
        .then( (data) => {
          this.championnat = data.data
        })
        .catch( (error) => {

        })
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/matchs/components/Read.vue